import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { key: 0 };
import { computed, inject, onMounted, reactive, ref } from "vue";
import { createProduct, initProduct } from "@/model/Product";
import { validationRules } from "@/ValidationRules";
import { BookingDurationTypeModel } from "@/model/enum/BookingDurationType.model";
import { FileServiceSymbol, LocationServiceSymbol, ProductServiceSymbol, ResourceServiceSymbol, TaxRateServiceSymbol } from "@/InjectionSymbols";
import { useMessageStore } from "@/stores/MessageStore";
import { Formatter } from "@/util/Formatter";
import TimelineTable from "@/components/admin/TimelineTable.vue";
import { useRouter } from "vue-router";
import ProductPricePanel from "@/components/admin/ProductPricePanel.vue";
import ProductTimeslotPanel from '@/components/admin/ProductTimeslotPanel.vue';
import { ResourceType } from "@/model/enum/ResourceType";
export default /*@__PURE__*/ _defineComponent({
    __name: 'EditProductView',
    props: {
        id: {
            type: String,
            required: false
        }
    },
    setup(__props) {
        const resourceService = inject(ResourceServiceSymbol);
        const productService = inject(ProductServiceSymbol);
        const locationService = inject(LocationServiceSymbol);
        const fileService = inject(FileServiceSymbol);
        const taxRateService = inject(TaxRateServiceSymbol);
        const messageStore = useMessageStore();
        const router = useRouter();
        const props = __props;
        const editProduct = reactive(createProduct());
        const resourceGroups = reactive([]);
        const resources = reactive([]);
        const locations = reactive([]);
        const products = reactive([]);
        const taxrates = reactive([]);
        let crosssellSelect = ref(null);
        const imageUrl = ref("");
        let form = ref(null);
        const dialog = ref(false);
        let selectedImage;
        let saveInFlight = false;
        onMounted(() => {
            resourceService?.loadAllResources().then(resourcesLoaded);
            resourceService?.loadAllResourceGroups().then(resourceGroupsLoaded);
            locationService?.loadAllLocations(locationsLoaded);
            productService?.loadAllProducts().then(response => {
                products.length = 0;
                response.forEach(value => products.push(value));
            });
            taxRateService.loadAllTaxRates().then(response => {
                taxrates.length = 0;
                response.forEach(value => taxrates.push(value));
            });
            if (props.id) {
                loadProduct();
            }
        });
        const crossSellProducts = computed(() => {
            let map = new Map();
            products.forEach(product => map.set(product.id, product));
            let list = [];
            editProduct.crossSells.forEach(crosssell => list.push(map.get(crosssell)));
            return list;
        });
        function loadProduct() {
            if (props.id) {
                productService.loadProduct(props.id).then((product) => {
                    productLoaded(product);
                });
            }
        }
        function addCrosssell(crosssell) {
            if (crosssell) {
                if (crosssellSelect.value) {
                    crosssellSelect.value.reset();
                    crosssellSelect.value.blur();
                }
                editProduct.crossSells.push(crosssell.id);
            }
        }
        function removeCrossSell(item) {
            editProduct.crossSells.splice(editProduct.crossSells.indexOf(item.id), 1);
        }
        function productLoaded(product) {
            initProduct(editProduct, product);
            loadImage(product);
        }
        async function loadImage(product) {
            const image = product?.image;
            if (image) {
                const imageSrc = await fileService.getImageSrc(image);
                if (imageSrc && imageSrc.length > 0) {
                    imageUrl.value = imageSrc;
                }
            }
        }
        function resourceGroupsLoaded(resourceGroupsFromServer) {
            resourceGroups.length = 0;
            resourceGroups.push(...resourceGroupsFromServer);
        }
        function resourcesLoaded(resourcesFromServer) {
            resources.length = 0;
            resources.push(...resourcesFromServer);
        }
        function locationsLoaded(locationsFromServer) {
            locations.length = 0;
            locations.push(...locationsFromServer);
        }
        function onImageSelected(newSelectedImage) {
            if (newSelectedImage && !Array.isArray(newSelectedImage)) {
                imageUrl.value = URL.createObjectURL(newSelectedImage);
                selectedImage = newSelectedImage;
            }
        }
        function updateResourceGroups(resourceGroups, resourceType) {
            let newGroups = editProduct.resourceGroups.filter(group => group.resourceType != resourceType);
            newGroups.push(...resourceGroups);
            editProduct.resourceGroups = newGroups;
        }
        function updateResources(resources, resourceType) {
            let newResources = editProduct.resources.filter(res => res.resourceType != resourceType);
            newResources.push(...resources);
            editProduct.resources = newResources;
        }
        function save() {
            form.value.resetValidation();
            form.value.validate().then((result) => {
                if (result.valid) {
                    saveInFlight = true;
                    if (selectedImage) {
                        saveImage();
                    }
                    else {
                        saveData();
                    }
                }
            });
        }
        function saveImage() {
            fileService?.uploadImage(selectedImage).then(response => {
                editProduct.image = response.data;
            }).catch(() => {
                messageStore.addError("Fehler beim Upload des Bildes");
            }).finally(() => {
                saveData();
            });
        }
        function saveData() {
            let promise;
            if (editProduct.id) {
                promise = productService.updateProduct(editProduct);
            }
            else {
                promise = productService.createProduct(editProduct);
            }
            promise.then(response => {
                initProduct(editProduct, response.data);
                saveInFlight = false;
                messageStore.addMessage("Erfolgreich gespeichert");
            }).catch((error) => {
                console.log(error);
                messageStore.addError("Fehler beim Speichern");
                saveInFlight = false;
            });
        }
        function deleteProduct() {
            productService.deleteProduct(editProduct.id).then(() => {
                messageStore.addMessage("Leistung gelöscht!");
                dialog.value = false;
                router.push('/admin/products');
            });
        }
        return (_ctx, _cache) => {
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_spacer = _resolveComponent("v-spacer");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_dialog = _resolveComponent("v-dialog");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_textarea = _resolveComponent("v-textarea");
            const _component_v_img = _resolveComponent("v-img");
            const _component_v_file_input = _resolveComponent("v-file-input");
            const _component_v_select = _resolveComponent("v-select");
            const _component_v_expansion_panel = _resolveComponent("v-expansion-panel");
            const _component_v_alert = _resolveComponent("v-alert");
            const _component_v_switch = _resolveComponent("v-switch");
            const _component_v_autocomplete = _resolveComponent("v-autocomplete");
            const _component_v_data_table = _resolveComponent("v-data-table");
            const _component_v_expansion_panels = _resolveComponent("v-expansion-panels");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            const _component_v_form = _resolveComponent("v-form");
            return (_openBlock(), _createBlock(_component_v_card, { class: "ma-0" }, {
                default: _withCtx(() => [
                    (!editProduct.id)
                        ? (_openBlock(), _createBlock(_component_v_container, {
                            key: 0,
                            fluid: true,
                            class: "text-h4 text-start"
                        }, {
                            default: _withCtx(() => _cache[19] || (_cache[19] = [
                                _createTextVNode("Neue Leistung anlegen")
                            ])),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (editProduct.id)
                        ? (_openBlock(), _createBlock(_component_v_container, {
                            key: 1,
                            fluid: true,
                            class: "text-h4 text-start d-flex"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(editProduct.title) + " ", 1),
                                _createVNode(_component_v_spacer),
                                _createVNode(_component_v_dialog, {
                                    modelValue: dialog.value,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((dialog).value = $event)),
                                    "max-width": "500px"
                                }, {
                                    activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_btn, _mergeProps(props, {
                                            color: "error",
                                            "data-cy": "deleteProduct"
                                        }), {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_icon, null, {
                                                    default: _withCtx(() => _cache[20] || (_cache[20] = [
                                                        _createTextVNode("mdi-delete")
                                                    ])),
                                                    _: 1
                                                }),
                                                _cache[21] || (_cache[21] = _createTextVNode(" Löschen "))
                                            ]),
                                            _: 2
                                        }, 1040)
                                    ]),
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_card, null, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_card_title, { class: "pb-0" }, {
                                                    default: _withCtx(() => _cache[22] || (_cache[22] = [
                                                        _createElementVNode("span", { class: "text-h5" }, "Leistung wirklich löschen?", -1)
                                                    ])),
                                                    _: 1
                                                }),
                                                _createVNode(_component_v_card_text, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_container, { class: "d-flex justify-center" }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_btn, {
                                                                    class: "mx-2",
                                                                    color: "error",
                                                                    onClick: deleteProduct,
                                                                    "data-cy": "confirmDelete"
                                                                }, {
                                                                    default: _withCtx(() => _cache[23] || (_cache[23] = [
                                                                        _createTextVNode("Löschen")
                                                                    ])),
                                                                    _: 1
                                                                }),
                                                                _createVNode(_component_v_btn, {
                                                                    class: "mx-2",
                                                                    onClick: _cache[0] || (_cache[0] = ($event) => (dialog.value = false))
                                                                }, {
                                                                    default: _withCtx(() => _cache[24] || (_cache[24] = [
                                                                        _createTextVNode("Abbrechen")
                                                                    ])),
                                                                    _: 1
                                                                })
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }, 8, ["modelValue"])
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    _createVNode(_component_v_form, {
                        ref_key: "form",
                        ref: form
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_expansion_panels, {
                                variant: 'inset',
                                "model-value": ['basicData'],
                                class: "px-4"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_expansion_panel, {
                                        eager: true,
                                        value: "basicData"
                                    }, {
                                        title: _withCtx(() => [
                                            _createVNode(_component_v_container, { class: "ma-0 pa-0 text-start font-weight-bold" }, {
                                                default: _withCtx(() => _cache[25] || (_cache[25] = [
                                                    _createTextVNode("Basis Daten")
                                                ])),
                                                _: 1
                                            })
                                        ]),
                                        text: _withCtx(() => [
                                            _createVNode(_component_v_container, { class: "d-flex v-col-12 px-0" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_container, { class: "pa-0 ma-0 d-flex flex-wrap flex-grow-1" }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_text_field, {
                                                                class: "v-col-2 compact",
                                                                modelValue: editProduct.id,
                                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((editProduct.id) = $event)),
                                                                label: "ID",
                                                                disabled: true,
                                                                variant: "outlined",
                                                                density: "compact"
                                                            }, null, 8, ["modelValue"]),
                                                            _createVNode(_component_v_text_field, {
                                                                class: "v-col-10 compact",
                                                                modelValue: editProduct.title,
                                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((editProduct.title) = $event)),
                                                                rules: [_unref(validationRules).required],
                                                                label: "Titel",
                                                                variant: "outlined",
                                                                "data-cy": "title",
                                                                density: "compact",
                                                                maxlength: "255",
                                                                counter: ""
                                                            }, null, 8, ["modelValue", "rules"]),
                                                            _createVNode(_component_v_text_field, {
                                                                class: "v-col-12 compact",
                                                                modelValue: editProduct.subtitle,
                                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((editProduct.subtitle) = $event)),
                                                                rules: [],
                                                                label: "Untertitel",
                                                                variant: "outlined",
                                                                "data-cy": "subtitle",
                                                                density: "compact",
                                                                maxlength: "255",
                                                                counter: ""
                                                            }, null, 8, ["modelValue"]),
                                                            _createVNode(_component_v_textarea, {
                                                                class: "v-col-12 compact",
                                                                modelValue: editProduct.shortDescription,
                                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((editProduct.shortDescription) = $event)),
                                                                label: "Kurzbeschreibung",
                                                                variant: "outlined",
                                                                "data-cy": "shortDescription",
                                                                density: "compact",
                                                                maxlength: "255",
                                                                counter: ""
                                                            }, null, 8, ["modelValue"])
                                                        ]),
                                                        _: 1
                                                    }),
                                                    _createVNode(_component_v_container, { class: "py-0 ma-0 d-flex w-auto" }, {
                                                        default: _withCtx(() => [
                                                            (_openBlock(), _createBlock(_component_v_img, {
                                                                key: imageUrl.value,
                                                                src: imageUrl.value,
                                                                height: "264px",
                                                                width: "396px",
                                                                "max-width": "396px",
                                                                class: "border-solid ma-0",
                                                                onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.$refs.fileInput.click())),
                                                                "data-cy": "imageUpload",
                                                                cover: true
                                                            }, {
                                                                placeholder: _withCtx(() => [
                                                                    (!_unref(selectedImage))
                                                                        ? (_openBlock(), _createBlock(_component_v_container, {
                                                                            key: 0,
                                                                            class: "d-flex align-center justify-center fill-height"
                                                                        }, {
                                                                            default: _withCtx(() => _cache[26] || (_cache[26] = [
                                                                                _createTextVNode(" Bild hinzufügen ")
                                                                            ])),
                                                                            _: 1
                                                                        }))
                                                                        : _createCommentVNode("", true)
                                                                ]),
                                                                _: 1
                                                            }, 8, ["src"])),
                                                            _withDirectives(_createVNode(_component_v_file_input, {
                                                                ref: "fileInput",
                                                                accept: "image/*",
                                                                label: "Select Image",
                                                                "onUpdate:modelValue": onImageSelected
                                                            }, null, 512), [
                                                                [_vShow, false]
                                                            ])
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_container, { class: "d-flex flex-wrap pa-0 ma-0" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_textarea, {
                                                        class: "v-col-12 compact",
                                                        modelValue: editProduct.description,
                                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((editProduct.description) = $event)),
                                                        label: "Beschreibung",
                                                        variant: "outlined",
                                                        "data-cy": "description",
                                                        density: "compact",
                                                        maxlength: "1000",
                                                        counter: ""
                                                    }, null, 8, ["modelValue"]),
                                                    _createVNode(_component_v_select, {
                                                        class: "v-col-8 compact",
                                                        rules: [_unref(validationRules).required],
                                                        modelValue: editProduct.bookingDurationType,
                                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((editProduct.bookingDurationType) = $event)),
                                                        items: Object.values(_unref(BookingDurationTypeModel)),
                                                        label: "Buchungsdauer Typ",
                                                        variant: "outlined",
                                                        "data-cy": "bookingDurationType",
                                                        density: "compact"
                                                    }, null, 8, ["rules", "modelValue", "items"]),
                                                    (editProduct.bookingDurationType === _unref(BookingDurationTypeModel).FIXED)
                                                        ? (_openBlock(), _createBlock(_component_v_text_field, {
                                                            key: 0,
                                                            class: "v-col-4 compact",
                                                            modelValue: editProduct.bookingIntervalLength,
                                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((editProduct.bookingIntervalLength) = $event)),
                                                            rules: [_unref(validationRules).required],
                                                            label: "Fixe Buchungsdauer (Tage)",
                                                            variant: "outlined",
                                                            "data-cy": "bookingIntervalLength",
                                                            density: "compact"
                                                        }, null, 8, ["modelValue", "rules"]))
                                                        : _createCommentVNode("", true),
                                                    _createVNode(_component_v_select, {
                                                        class: "v-col-6 compact",
                                                        "model-value": editProduct.resourceGroups.filter(group => group.resourceType == _unref(ResourceType).ATTRIBUTE),
                                                        items: resourceGroups.filter(group => group.resourceType == _unref(ResourceType).ATTRIBUTE),
                                                        "item-title": "name",
                                                        label: "Buchungsangaben (Gruppiert)",
                                                        variant: "outlined",
                                                        "return-object": "",
                                                        multiple: true,
                                                        "data-cy": "attributeGroups",
                                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => (updateResourceGroups($event, _unref(ResourceType).ATTRIBUTE))),
                                                        density: "compact"
                                                    }, null, 8, ["model-value", "items"]),
                                                    _createVNode(_component_v_select, {
                                                        class: "v-col-6 compact",
                                                        "model-value": editProduct.resources.filter(res => res.resourceType == _unref(ResourceType).ATTRIBUTE),
                                                        items: resources.filter(res => res.resourceType == _unref(ResourceType).ATTRIBUTE),
                                                        "item-title": "name",
                                                        label: "Buchungsangaben (Einzeln)",
                                                        variant: "outlined",
                                                        "return-object": "",
                                                        multiple: true,
                                                        "data-cy": "attributes",
                                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => (updateResources($event, _unref(ResourceType).ATTRIBUTE))),
                                                        density: "compact"
                                                    }, null, 8, ["model-value", "items"]),
                                                    _createVNode(_component_v_select, {
                                                        class: "v-col-6 compact",
                                                        "model-value": editProduct.resourceGroups.filter(group => group.resourceType == _unref(ResourceType).RESOURCE),
                                                        items: resourceGroups.filter(group => group.resourceType == _unref(ResourceType).RESOURCE),
                                                        "item-title": "name",
                                                        label: "Wählbare Resourcen (Gruppiert)",
                                                        variant: "outlined",
                                                        "return-object": "",
                                                        multiple: true,
                                                        "data-cy": "resourceGroups",
                                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => (updateResourceGroups($event, _unref(ResourceType).RESOURCE))),
                                                        density: "compact"
                                                    }, null, 8, ["model-value", "items"]),
                                                    _createVNode(_component_v_select, {
                                                        class: "v-col-6 compact",
                                                        "model-value": editProduct.resources.filter(res => res.resourceType == _unref(ResourceType).RESOURCE),
                                                        items: resources.filter(res => res.resourceType == _unref(ResourceType).RESOURCE),
                                                        "item-title": "name",
                                                        label: "Wählbare Ressourcen (Einzeln)",
                                                        variant: "outlined",
                                                        "return-object": "",
                                                        multiple: true,
                                                        "data-cy": "resources",
                                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => (updateResources($event, _unref(ResourceType).RESOURCE))),
                                                        density: "compact"
                                                    }, null, 8, ["model-value", "items"]),
                                                    _createVNode(_component_v_select, {
                                                        class: "v-col-6 compact",
                                                        modelValue: editProduct.startLocation,
                                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((editProduct.startLocation) = $event)),
                                                        items: locations,
                                                        "item-title": "name",
                                                        label: "Start Location",
                                                        variant: "outlined",
                                                        "return-object": "",
                                                        "data-cy": "startLocation",
                                                        density: "compact"
                                                    }, null, 8, ["modelValue", "items"]),
                                                    _createVNode(_component_v_select, {
                                                        class: "v-col-6 compact",
                                                        modelValue: editProduct.endLocation,
                                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((editProduct.endLocation) = $event)),
                                                        items: locations,
                                                        "item-title": "name",
                                                        label: "End Location",
                                                        variant: "outlined",
                                                        "return-object": "",
                                                        "data-cy": "endLocation",
                                                        density: "compact"
                                                    }, null, 8, ["modelValue", "items"])
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_expansion_panel, {
                                        value: "timeslots",
                                        "data-cy": "timeslotPanel",
                                        eager: true
                                    }, {
                                        title: _withCtx(() => [
                                            _createVNode(_component_v_container, { class: "ma-0 pa-0 text-start font-weight-bold" }, {
                                                default: _withCtx(() => _cache[27] || (_cache[27] = [
                                                    _createTextVNode("Zeitslots")
                                                ])),
                                                _: 1
                                            })
                                        ]),
                                        text: _withCtx(() => [
                                            (editProduct.bookingDurationType === _unref(BookingDurationTypeModel).VARIABLE)
                                                ? (_openBlock(), _createBlock(_component_v_container, {
                                                    key: 0,
                                                    class: "d-flex justify-center"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_alert, {
                                                            "data-cy": "variableTimeslotsAlert",
                                                            type: "warning",
                                                            elevation: "2"
                                                        }, {
                                                            default: _withCtx(() => _cache[28] || (_cache[28] = [
                                                                _createTextVNode(" Zeitslots bei variabler Buchungsdauer werden (noch) nicht unterstützt. ")
                                                            ])),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _: 1
                                                }))
                                                : (!editProduct.id)
                                                    ? (_openBlock(), _createBlock(_component_v_container, {
                                                        key: 1,
                                                        class: "d-flex justify-center"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_alert, {
                                                                "data-cy": "timeslotsAlert",
                                                                type: "info",
                                                                elevation: "2"
                                                            }, {
                                                                default: _withCtx(() => _cache[29] || (_cache[29] = [
                                                                    _createTextVNode(" Bitte speichere die Leistung bevor du die Timeslots bearbeitest. ")
                                                                ])),
                                                                _: 1
                                                            })
                                                        ]),
                                                        _: 1
                                                    }))
                                                    : (_openBlock(), _createBlock(ProductTimeslotPanel, {
                                                        key: 2,
                                                        timeslots: editProduct.timeslots,
                                                        "product-id": editProduct.id,
                                                        onOnTimeslotUpdated: loadProduct
                                                    }, null, 8, ["timeslots", "product-id"]))
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_expansion_panel, {
                                        value: "prices",
                                        "data-cy": "pricingPanel",
                                        eager: true
                                    }, {
                                        title: _withCtx(() => [
                                            _createVNode(_component_v_container, { class: "ma-0 pa-0 text-start font-weight-bold" }, {
                                                default: _withCtx(() => _cache[30] || (_cache[30] = [
                                                    _createTextVNode("Preise")
                                                ])),
                                                _: 1
                                            })
                                        ]),
                                        text: _withCtx(() => [
                                            _createVNode(ProductPricePanel, {
                                                priceStructure: editProduct.priceStructure,
                                                "onUpdate:priceStructure": _cache[16] || (_cache[16] = ($event) => ((editProduct.priceStructure) = $event)),
                                                product: editProduct
                                            }, null, 8, ["priceStructure", "product"]),
                                            _createVNode(_component_v_container, { class: "d-flex flex-wrap ma-0 pa-0 pt-2 v-col-12" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_container, { class: "pa-0 pt-4 ma-0 v-col-12 d-flex" }, {
                                                        default: _withCtx(() => [
                                                            (editProduct.bookingDurationType === _unref(BookingDurationTypeModel).VARIABLE)
                                                                ? (_openBlock(), _createBlock(_component_v_switch, {
                                                                    key: 0,
                                                                    modelValue: editProduct.priceStructure.pricedPerNight,
                                                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((editProduct.priceStructure.pricedPerNight) = $event)),
                                                                    label: "Abrechnung pro Nacht",
                                                                    color: "green",
                                                                    inset: true,
                                                                    density: "compact"
                                                                }, null, 8, ["modelValue"]))
                                                                : _createCommentVNode("", true),
                                                            _createVNode(_component_v_select, {
                                                                modelValue: editProduct.priceStructure.taxRate,
                                                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((editProduct.priceStructure.taxRate) = $event)),
                                                                rules: [_unref(validationRules).required],
                                                                items: taxrates,
                                                                "item-title": "rate",
                                                                label: "Mehrwertsteuer",
                                                                "item-props": (item) => ({ title: _unref(Formatter).decimalToPercent(item.rate) }),
                                                                variant: "outlined",
                                                                density: "compact",
                                                                "return-object": "",
                                                                "data-cy": "productTaxRate"
                                                            }, null, 8, ["modelValue", "rules", "items", "item-props"])
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_expansion_panel, { eager: true }, {
                                        title: _withCtx(() => [
                                            _createVNode(_component_v_container, { class: "ma-0 pa-0 text-start font-weight-bold" }, {
                                                default: _withCtx(() => _cache[31] || (_cache[31] = [
                                                    _createTextVNode("Cross-Sells")
                                                ])),
                                                _: 1
                                            })
                                        ]),
                                        text: _withCtx(() => [
                                            _createVNode(_component_v_container, { class: "py-0" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_autocomplete, {
                                                        ref_key: "crosssellSelect",
                                                        ref: crosssellSelect,
                                                        items: products,
                                                        "item-title": "title",
                                                        label: "Leistung hinzufügen",
                                                        "return-object": "",
                                                        "onUpdate:modelValue": addCrosssell
                                                    }, null, 8, ["items"]),
                                                    _createVNode(_component_v_data_table, {
                                                        "items-per-page": 5,
                                                        items: crossSellProducts.value,
                                                        headers: [
                                                            {
                                                                title: 'Leistung',
                                                                key: 'title',
                                                                sortable: false
                                                            },
                                                            { title: '', key: 'actions', sortable: false },
                                                        ]
                                                    }, {
                                                        [`item.actions`]: _withCtx(({ item }) => [
                                                            _createVNode(_component_v_icon, {
                                                                size: "small",
                                                                onClick: ($event) => (removeCrossSell(item))
                                                            }, {
                                                                default: _withCtx(() => _cache[32] || (_cache[32] = [
                                                                    _createTextVNode(" mdi-delete ")
                                                                ])),
                                                                _: 2
                                                            }, 1032, ["onClick"])
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["items"])
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_expansion_panel, {
                                        value: "timeline",
                                        "data-cy": "timelinePanel",
                                        eager: true
                                    }, {
                                        title: _withCtx(() => [
                                            _createVNode(_component_v_container, { class: "ma-0 pa-0 text-start font-weight-bold" }, {
                                                default: _withCtx(() => _cache[33] || (_cache[33] = [
                                                    _createTextVNode("Timeline")
                                                ])),
                                                _: 1
                                            })
                                        ]),
                                        text: _withCtx(() => [
                                            (!editProduct.id)
                                                ? (_openBlock(), _createBlock(_component_v_container, { key: 0 }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_container, { class: "d-flex justify-center" }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_alert, {
                                                                    "data-cy": "timeTableAlert",
                                                                    type: "info",
                                                                    elevation: "2"
                                                                }, {
                                                                    default: _withCtx(() => _cache[34] || (_cache[34] = [
                                                                        _createTextVNode(" Bitte speichern Sie die Leistung bevor Sie die Timeline bearbeiten ")
                                                                    ])),
                                                                    _: 1
                                                                })
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _: 1
                                                }))
                                                : (_openBlock(), _createBlock(TimelineTable, {
                                                    key: 1,
                                                    "product-id": editProduct.id,
                                                    events: editProduct.timelineEvents,
                                                    locations: locations,
                                                    timeslots: editProduct.timeslots,
                                                    onOnEventUpdated: loadProduct
                                                }, null, 8, ["product-id", "events", "locations", "timeslots"]))
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_container, { class: "d-flex ma-0" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                        "data-cy": "save",
                                        onClick: save
                                    }, {
                                        default: _withCtx(() => [
                                            (!_unref(saveInFlight))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Alles Speichern"))
                                                : _createCommentVNode("", true),
                                            (_unref(saveInFlight))
                                                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                                    key: 1,
                                                    indeterminate: true
                                                }))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }, 512)
                ]),
                _: 1
            }));
        };
    }
});
